export const types ={
    authLogin : '[AUTH] Login',
    authLogout : '[AUTH] Logout',
    authStartLoading : '[AUTH] Start Loading',
    authEndLoading : '[AUTH] End Loading',
    authRegister:'[AUTH] Register',
    authCheckingEnd: '[AUTH] Checking End',

    catStartLoading : '[CATEGORY] Start Loading',
    catEndLoading : '[CATEGORY] End Loading',
    catRetrieveCategories: '[CATEGORY] Retrieve all categories from user',

    noteRetrieveNotes : '[NOTES] Retrieve all notes from user/category',
    noteStartLoading : '[NOTES] Start Loading',
    noteEndLoading : '[NOTES] End Loading',
    
}